import ModalStore from './ModalStore'
import { insuranceProductServer } from '../common/api'

class Product extends ModalStore {
  constructor() {
    super('product', {
      all: [],
      current: [],
      configs: [],
    })
  }

  fetch = async param => {
    const res = await insuranceProductServer.get('/life_products', param)
    this.$setState('all', res.data.data.products)
  }

  create = async param => {
    await insuranceProductServer.post('/life_products', param)
  }

  fetchConfig = async () => {
    const resConfigs = await insuranceProductServer.get(`/life_products/config`)
    this.$setState('configs', resConfigs.data.data.configs.attributes)
  }

  fetchById = async param => {
    const res = await insuranceProductServer.get(`/life_products/${param}`)

    this.$setState('current', res.data.data.product)
  }

  update = async (id, param) => {
    const res = await insuranceProductServer.put(`/life_products/${id}`, param)
    this.$setState('current', res.data.data.product)
  }

  delete = async id => {
    await insuranceProductServer.delete(`/life_products/${id}`)
  }

  updateStatusPublishDetail = async (id, param) => {
    const res = await insuranceProductServer.post(
      `/life_products/${id}/publish`
    )

    this.$setState('current', res.data.data.product)
  }

  updateStatusUnpublishedDetail = async (id, param) => {
    const res = await insuranceProductServer.post(
      `/life_products/${id}/unpublished`
    )

    this.$setState('current', res.data.data.product)
  }

  updateStatusPublish = async (id, param) => {
    const res = await insuranceProductServer.post(
      `/life_products/${id}/publish`
    )
    const response = res.data.data

    const products = this.$getState('all')

    await products.forEach(product => {
      if (product.id === response.product.id) {
        product.status = response.product.status
      }
    })

    this.$setState('all', products)
  }

  updateStatusUnpublished = async (id, param) => {
    const res = await insuranceProductServer.post(
      `/life_products/${id}/unpublished`
    )
    const response = res.data.data

    const products = this.$getState('all')

    await products.forEach(product => {
      if (product.id === response.product.id) {
        product.status = response.product.status
      }
    })

    this.$setState('all', products)
  }

  updateGraph = async (id, param) => {
    const res = await insuranceProductServer.post(
      `/life_products/${id}/graph`,
      param
    )

    this.$setState('current', res.data.data.product)
  }

  updateTqldGraph = async (id, param) => {
    const res = await insuranceProductServer.post(
      `/life_products/${id}/tqld_graph`,
      param
    )
    this.$setState('current', res.data.data.product)
  }

  clearData = () => {
    this.$setState('configs', [])
    this.$setState('current', [])
  }
}

export default new Product()
